import { useEffect } from "react";
import {
  Typography,
  Button,
  Box,
  Grid,
  CardMedia,
  TextField,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { Stack, styled } from "@mui/system";
import { useState } from "react";
import axios from "axios";
import { CreateDropDown } from "../../components/CreatePagesComponents";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../constants/context";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import { fetchPractitioners } from "../../redux/reducers/practitioners.reducer";
import { BASE_URL } from "../../constants/config";
import { CONSULTATION_COPY } from "../../constants/consultation";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../components/CustomSnackbar";
const HeroSection = styled(Box)(({ theme }) => ({
  backgroundColor: "#EAE6DA",
  color: "#4c2e1f",
  padding: "10px 20px",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));
const StyledButtonWrapper = styled(Box)(({ theme }) => ({
  display: "inline-block",
}));
const StyledBottomBackgroundComplete = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: "0%",
  width: "265px",
  height: "50%",
  backgroundImage: `url(${require("../../assets/images/complete-bg.webp")})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  zIndex: 2,
}));
const Container = styled(Box)(({ theme }) => ({
  padding: "40px",
  marginTop: "5%",
  backgroundColor: "#EAE6DA",
  borderRadius: "30px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
}));

const ContainerHeader = styled(Typography)(({ theme }) => ({
  color: "#492A18",
  fontStyle: "Cinzel",
  fontSize: "30px",
  marginBottom: "20px",
  textAlign: "center",
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  color: "#492A18",
  marginBottom: "30px",
  fontFamily: "Calibri",
  fontSize: "30px",
  textAlign: "center",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  border: "1px solid #492A18",
  color: "#492A18",
  borderRadius: "500px",
  textTransform: "none",
  padding: "10px 20px",
  fontSize: "20px",
  marginBottom: "20px",
  textAlign: "center",
  fontFamily: "Calibri",
  "&:hover": {
    backgroundColor: "#4C2E1F",
    color: "#FFF",
  },
}));

const NextButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#492A18",
  fontFamily: "Calibri",
  borderRadius: "12px",
  color: "#FFF",
  textTransform: "none",
  padding: "10px 20px",
  fontSize: "16px",
  marginTop: "30px",
  "&:hover": {
    backgroundColor: "#6a4433",
  },
}));
const states = [
  { label: "Alabama", value: "Alabama" },
  { label: "Alaska", value: "Alaska" },
  { label: "Arizona", value: "Arizona" },
  { label: "Arkansas", value: "Arkansas" },
  { label: "California", value: "California" },
  { label: "Colorado", value: "Colorado" },
  { label: "Connecticut", value: "Connecticut" },
  { label: "Delaware", value: "Delaware" },
  { label: "Florida", value: "Florida" },
  { label: "Georgia", value: "Georgia" },
  { label: "Hawaii", value: "Hawaii" },
  { label: "Idaho", value: "Idaho" },
  { label: "Illinois", value: "Illinois" },
  { label: "Indiana", value: "Indiana" },
  { label: "Iowa", value: "Iowa" },
  { label: "Kansas", value: "Kansas" },
  { label: "Kentucky", value: "Kentucky" },
  { label: "Louisiana", value: "Louisiana" },
  { label: "Maine", value: "Maine" },
  { label: "Maryland", value: "Maryland" },
  { label: "Massachusetts", value: "Massachusetts" },
  { label: "Michigan", value: "Michigan" },
  { label: "Minnesota", value: "Minnesota" },
  { label: "Mississippi", value: "Mississippi" },
  { label: "Missouri", value: "Missouri" },
  { label: "Montana", value: "Montana" },
  { label: "Nebraska", value: "Nebraska" },
  { label: "Nevada", value: "Nevada" },
  { label: "New Hampshire", value: "New Hampshire" },
  { label: "New Jersey", value: "New Jersey" },
  { label: "New Mexico", value: "New Mexico" },
  { label: "New York", value: "New York" },
  { label: "North Carolina", value: "North Carolina" },
  { label: "North Dakota", value: "North Dakota" },
  { label: "Ohio", value: "Ohio" },
  { label: "Oklahoma", value: "Oklahoma" },
  { label: "Oregon", value: "Oregon" },
  { label: "Pennsylvania", value: "Pennsylvania" },
  { label: "Rhode Island", value: "Rhode Island" },
  { label: "South Carolina", value: "South Carolina" },
  { label: "South Dakota", value: "South Dakota" },
  { label: "Tennessee", value: "Tennessee" },
  { label: "Texas", value: "Texas" },
  { label: "Utah", value: "Utah" },
  { label: "Vermont", value: "Vermont" },
  { label: "Virginia", value: "Virginia" },
  { label: "Washington", value: "Washington" },
  { label: "West Virginia", value: "West Virginia" },
  { label: "Wisconsin", value: "Wisconsin" },
  { label: "Wyoming", value: "Wyoming" },
];
const languages = [
  { label: "English", value: "English" },
  { label: "Arabic", value: "Arabic" },
  { label: "Chinese (Mandarin)", value: "Chinese" },
  { label: "French", value: "French" },
  { label: "Greek", value: "Greek" },
  { label: "Italian", value: "Italian" },
  { label: "Portuguese", value: "Portuguese" },
  { label: "Romanian", value: "Romanian" },
  { label: "Russian", value: "Russian" },
  { label: "Spanish", value: "Spanish" },
];
export const Booking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    data,
    loading,
    error: reduxError,
  } = useSelector((state) => state.practitioners);
  useEffect(() => {
    dispatch(fetchPractitioners());
  }, [dispatch]);

  const getCustomFieldValue = (customFields, fieldId) => {
    const field = customFields?.find((field) => field.id === fieldId);
    return field?.value || "";
  };

  useEffect(() => {
    if (reduxError) {
      setErrorMsg("Failed to load practitioners. Please refresh the page.");
      setShowError(true);
    }
  }, [reduxError]);

  const { stepper, setStepper } = useUser();
  const [selectedState, setSelectedState] = useState("");
  const [, setSelectedLanguage] = useState("");
  const [patient, setPatient] = useState({});

  // Snackbar states
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState("");
  const updatePatient = (key, value, callback) => {
    setPatient((prev) => {
      const updated = { ...prev, [key]: value };
      if (callback) callback(updated);
      return updated;
    });
  };

  const handleSubmit = async (updatedPatient = patient) => {
    try {
      const payload = {
        ...updatedPatient,
        dob: updatedPatient.dob
          ? `${String(updatedPatient.dob.getMonth() + 1).padStart(
              2,
              "0",
            )}-${String(updatedPatient.dob.getDate()).padStart(
              2,
              "0",
            )}-${updatedPatient.dob.getFullYear()}`
          : null,
      };
      const response = await axios.post(
        `${BASE_URL}/user/create-patient`,
        payload,
      );

      if (response.status >= 200 && response.status < 300) {
        setStepper(10);
        setConfirmationMsg("Client information submitted successfully!");
        setShowConfirmation(true);
      }
    } catch (submitError) {
      console.error("Error submitting client data:", submitError);
      setErrorMsg(
        submitError.response?.data?.message ||
          "Failed to submit client information. Please try again.",
      );
      setShowError(true);
    }
  };

  return (
    <>
      <Box className="homepage" sx={{ backgroundColor: "#EAE6DA" }}>
        {/* Hero Section */}
        <HeroSection>
          <Grid
            container
            spacing={4}
            sx={{
              "&.MuiGrid-container": {
                margin: "0px 20px",
                width: "100%",
              },
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{ marginTop: "2%", textAlign: "center" }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontFamily: "Cinzel",
                  fontWeight: 400,
                  marginBottom: "20px",
                  fontSize: "60px",
                  zIndex: -1,
                }}
              >
                Convenient and Affordable Hypnotherapy{" "}
                <span style={{ fontFamily: "Cinzel-Bold" }}>with IPCH</span>
              </Typography>
              <StyledButtonWrapper>
                <StyledBottomBackgroundComplete />

                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Calibri, sans-serif",
                    marginBottom: "30px",
                  }}
                >
                  IPCH will match you with qualified practitioners based upon
                  your location, preferences, and our hypnotherapist
                  availability.
                </Typography>
              </StyledButtonWrapper>
            </Grid>
          </Grid>
        </HeroSection>
      </Box>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "30vh", // Full viewport height
          overflow: "hidden",
          zIndex: 1,
          backgroundColor: "#f8f5eb", // Beige background
        }}
      >
        {/* First Wave */}
        <Box
          component="img"
          src={require("../../assets/images/Vector 1.png")}
          alt="Wave 1"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "auto",
            minHeight: "200px", // Ensure the wave is tall enough
            zIndex: 1,
          }}
        />

        {/* Second Wave */}
        <Box
          component="img"
          src={require("../../assets/images/Vector 2.png")}
          alt="Wave 2"
          sx={{
            position: "absolute",
            top: "0%",
            width: "100%",
            height: "auto",
            minHeight: "200px", // Ensure the wave is tall enough
            zIndex: -1,
          }}
        />
      </Box>
      {stepper < 10 && (
        <Box
          sx={{
            backgroundColor: "#f8f5eb",
            px: 20,
            py: 10,
            //   display: "flex",
            //   alignItems: "center",
            //   justifyContent: "center",
            marginTop: "10%",
            //   flexDirection: "column",
            paddingBottom: "10%",
          }}
        >
          <Container>
            {/* Header */}
            <ContainerHeader variant="h6">
              {stepper >= 1 && (
                <ArrowBackIcon
                  style={{
                    float: "left",
                    width: "30px",
                    height: "60px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    let a = stepper;
                    setStepper((a = a - 1));
                  }}
                />
              )}
              Help us match you with the{" "}
              <span style={{ fontWeight: "bold" }}>right practitioner</span>.
            </ContainerHeader>

            <Divider
              sx={{
                margin: "1rem auto",
                maxWidth: "100% !important",
                color: "#492A18",
              }}
            />
            {stepper === 0 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    value={patient.firstName || ""}
                    onChange={(e) => updatePatient("firstName", e.target.value)}
                  />
                  <TextField
                    id="outlined-basic"
                    label="Last Name"
                    variant="outlined"
                    value={patient.lastName || ""}
                    onChange={(e) => updatePatient("lastName", e.target.value)}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {patient?.firstName?.trim() && patient?.lastName?.trim() && (
                    <NextButton
                      sx={{ marginTop: "20px" }}
                      onClick={() => setStepper(1)}
                    >
                      Next →
                    </NextButton>
                  )}
                </Box>
              </>
            )}
            {stepper === 1 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="Your email"
                    variant="outlined"
                    value={patient.email || ""}
                    type="email"
                    onChange={(e) => updatePatient("email", e.target.value)}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {patient?.email?.trim() && (
                    <NextButton
                      sx={{ marginTop: "20px" }}
                      onClick={() => setStepper(2)}
                    >
                      Next →
                    </NextButton>
                  )}
                </Box>
              </>
            )}
            {stepper === 2 && (
              <>
                <SubHeader variant="body1">
                  Are you seeking Hypnotherapy for?
                </SubHeader>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Buttons for Options */}
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <StyledButton
                      fullWidth
                      onClick={() => {
                        updatePatient(
                          "therapyType",
                          "Hypnotherapy (Adults 18+)",
                        );
                        setStepper(3);
                      }}
                    >
                      Hypnotherapy (Adults 18+)
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient(
                          "therapyType",
                          "Teen Hypnotherapy (Ages 14–17)",
                        );
                        setStepper(3);
                      }}
                      fullWidth
                    >
                      Teen Hypnotherapy (Ages 14–17)
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient(
                          "therapyType",
                          "Child & Adolescent Hypnotherapy (Under 18)",
                        );
                        setStepper(3);
                      }}
                      fullWidth
                    >
                      Child & Adolescent Hypnotherapy (Under 18)
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("therapyType", "Couples Hypnotherapy");
                        setStepper(3);
                      }}
                      fullWidth
                    >
                      Couples Hypnotherapy
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("therapyType", "Psychiatry");
                        setStepper(3);
                      }}
                      fullWidth
                    >
                      Psychiatry
                    </StyledButton>
                  </Stack>
                </Box>
              </>
            )}
            {stepper === 3 && (
              <>
                <SubHeader variant="body1">
                  Are you looking for insurance to pay for these services?
                </SubHeader>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Buttons for Options */}
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <StyledButton
                      fullWidth
                      onClick={() => {
                        updatePatient("insurance", "yes");
                        setStepper(4);
                      }}
                    >
                      Yes
                    </StyledButton>
                    <StyledButton
                      fullWidth
                      onClick={() => {
                        updatePatient("insurance", "no");
                        setStepper(4);
                      }}
                    >
                      No, I will pay out of pocket
                    </StyledButton>
                  </Stack>
                </Box>
              </>
            )}
            {stepper === 4 && (
              <>
                <SubHeader variant="body1">
                  What gender do you identify with?
                </SubHeader>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Buttons for Options */}
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "male");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Male
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "female");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Female
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "trans_female");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Transgender Female
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "trans_male");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Transgender Male
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "gender_queer");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Gender Queer{" "}
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "gender_variant");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Gender Variant
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "other");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Other
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("gender", "non_binary");
                        setStepper(5);
                      }}
                      fullWidth
                    >
                      Non-Binary
                    </StyledButton>
                  </Stack>
                </Box>
              </>
            )}
            {stepper === 5 && (
              <>
                <SubHeader variant="body1">
                  What gender would you prefer for your hypnotherapist to be?
                </SubHeader>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Buttons for Options */}
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <StyledButton
                      onClick={() => {
                        updatePatient("genderPreference", "male");
                        setStepper(6);
                      }}
                      fullWidth
                    >
                      Male
                    </StyledButton>
                    <StyledButton
                      fullWidth
                      onClick={() => {
                        updatePatient("genderPreference", "female");
                        setStepper(6);
                      }}
                    >
                      Female
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("genderPreference", "other");
                        setStepper(6);
                      }}
                      fullWidth
                    >
                      Other
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("genderPreference", "not_sure");
                        setStepper(6);
                      }}
                      fullWidth
                    >
                      I am not sure
                    </StyledButton>
                    <StyledButton
                      onClick={() => {
                        updatePatient("genderPreference", "no_preference");
                        setStepper(6);
                      }}
                      fullWidth
                    >
                      I have no preference
                    </StyledButton>
                  </Stack>
                </Box>
              </>
            )}
            {stepper === 6 && (
              <>
                <SubHeader variant="body1">
                  What is your Date of Birth?
                </SubHeader>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      inputFormat="MM/dd/yyyy"
                      label="Select your DOB"
                      maxDate={new Date()}
                      value={patient.dob}
                      onChange={(newValue) => {
                        updatePatient("dob", newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            width: "100%",
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "12px",
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  {/* Next Button */}
                  <NextButton
                    onClick={() => {
                      setStepper(7);
                    }}
                  >
                    Next →
                  </NextButton>
                </Box>
              </>
            )}
            {stepper === 7 && (
              <>
                <SubHeader variant="body1">Where do you live?</SubHeader>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <CreateDropDown
                      title="Select State*"
                      data={states}
                      value={selectedState}
                      setValue={(val) => {
                        setSelectedState(val);
                        updatePatient("state", val);
                      }}
                      noIcon
                    />

                    <StyledButton
                      onClick={() => {
                        updatePatient("state", "outside_us");
                        setSelectedState("");
                        setStepper(8);
                      }}
                      fullWidth
                    >
                      Outside of the US
                    </StyledButton>
                  </Stack>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Next Button */}
                  {patient?.state?.trim() && (
                    <NextButton
                      onClick={() => {
                        setStepper(8);
                      }}
                    >
                      Next →
                    </NextButton>
                  )}
                </Box>
              </>
            )}
            {stepper === 8 && (
              <>
                <SubHeader variant="body1">
                  Do you have a language preference?
                </SubHeader>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <CreateDropDown
                      title="Language *"
                      data={languages}
                      noIcon
                      setValue={(val) => {
                        setSelectedLanguage(val);
                        updatePatient("language", val);
                      }}
                    />
                  </Stack>
                  {patient.language && (
                    <NextButton
                      onClick={() => {
                        setStepper(9);
                      }}
                    >
                      Next →
                    </NextButton>
                  )}
                </Box>
              </>
            )}
            {stepper === 9 && (
              <>
                <SubHeader variant="body1">All Nirva sessions are online</SubHeader>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Stack spacing={2} width="100%" maxWidth="450px">
                    <StyledButton
                      onClick={() => {
                        updatePatient("sessionType", "online", (updated) => {
                          handleSubmit(updated);
                        });
                      }}
                      fullWidth
                    >
                      Continue with Online Sessions
                    </StyledButton>
                  </Stack>
                </Box>
              </>
            )}
          </Container>
          <StyledBottomBackgroundComplete style={{ marginTop: "-10%" }} />
        </Box>
      )}
      {stepper === 10 && (
        <>
          <Box
            sx={{
              backgroundColor: "#f8f5eb",
              p: 20,
              marginTop: "10%",
              position: "relative",
              textAlign: "center",
            }}
          >
            {/* Heading Section */}
            <Box
              component="img"
              src={require("../../assets/images/personalized-support.png")}
              alt="Service Icon"
              sx={{
                height: 100,
                width: 100,
                position: "absolute",
                top: "7%",
                left: "10%",
              }}
            />
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                fontFamily: "Cinzel-Bold",
                color: "#492A18",
                fontSize: "50px",
                mb: 1,
              }}
            >
              We've found three practitioners who best meet your needs.{" "}
              <Typography
                component="span"
                sx={{
                  fontFamily: "Cinzel",
                  fontSize: "50px",
                  color: "#492A18",
                  mb: 2,
                }}
              >
                {CONSULTATION_COPY.scheduleOne}
              </Typography>
            </Typography>

            {loading && (
              <Typography sx={{ mt: 4, color: "#492A18", fontSize: "20px" }}>
                Finding the best practitioners for you...
              </Typography>
            )}

            {!loading && (!data || data.length === 0) && (
              <Typography sx={{ mt: 4, color: "#492A18", fontSize: "20px" }}>
                No practitioners found. Please contact us directly for
                assistance.
              </Typography>
            )}

            <Grid
              container
              spacing={3}
              justifyContent="center"
              sx={{ padding: "20px" }}
            >
              {!loading &&
                data &&
                data.map((member, index) => {
                  // Extract bio and avatar from customFields
                  const bio = getCustomFieldValue(
                    member.customFields,
                    "xnRAkNyYWeXEiZQryrPV",
                  );
                  const avatar = getCustomFieldValue(
                    member.customFields,
                    "Uf5t1LoiYsc9z5teLXBr",
                  );
                  const fullName = `${member.firstName} ${member.lastName}`;

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={4}
                      key={member.id || index}
                    >
                      <Card
                        sx={{
                          maxWidth: 400,
                          height: 550, // Adjusted height
                          borderRadius: "30px",
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "#F9F6EE",
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 auto", // Center the card
                        }}
                      >
                        {/* Fixed height image container */}
                        <Box
                          sx={{
                            width: "100%",
                            height: "280px", // Adjusted image height
                            overflow: "hidden",
                            flexShrink: 0,
                          }}
                        >
                          <CardMedia
                            component="img"
                            alt={fullName}
                            image={avatar}
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              backgroundColor: "#EAE6DA",
                            }}
                          />
                        </Box>

                        {/* Content area */}
                        <CardContent
                          sx={{
                            backgroundColor: "#F9F6EE",
                            textAlign: "left",
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            p: 2,
                            overflow: "hidden",
                          }}
                        >
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{
                              marginBottom: "8px",
                              fontSize: "20px",
                              color: "#492A18",
                              fontFamily: "Cinzel-Bold",
                              flexShrink: 0,
                            }}
                          >
                            {fullName}
                          </Typography>

                          {/* Bio section with limited lines */}
                          <Box
                            sx={{
                              flexGrow: 1,
                              marginBottom: "12px",
                              overflow: "hidden",
                            }}
                          >
                            <Typography
                              variant="body2"
                              color="#492A18"
                              sx={{
                                fontSize: "14px",
                                fontFamily: "Calibri",
                                opacity: 0.7,
                                lineHeight: 1.5,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 5, // Show 5 lines
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {bio ||
                                "Experienced hypnotherapist dedicated to helping you achieve your goals."}
                            </Typography>
                          </Box>

                          {/* Button stays at bottom */}
                          <Button
                            variant="outlined"
                            sx={{
                              width: "100%",
                              color: "#492A18",
                              "&:hover": {
                                backgroundColor: "#6a4433",
                                color: "#FFF",
                              },
                              border: "1px solid #492A18",
                              textAlign: "center",
                              fontFamily: "Calibri",
                              fontSize: "14px",
                              fontWeight: 700,
                              flexShrink: 0,
                              mt: "auto",
                              padding: "8px 16px",
                            }}
                            onClick={() => {
                              navigate(`/practitioner-detail/${fullName}`, {
                                state: { user: member },
                              });
                            }}
                          >
                            Learn more →
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
        </>
      )}
      <ErrorSnackbar
        error={showError}
        handleCloseError={setShowError}
        errorMsg={errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={showConfirmation}
        text={confirmationMsg}
        handleSnackbarClose={setShowConfirmation}
      />
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "10vh", // Full viewport height
          overflow: "hidden",
          zIndex: 1,
          marginTop: "-4%",
          //backgroundColor: "#f8f5eb", // Beige background
        }}
      >
        {/* First Wave */}
        <Box
          component="img"
          src={require("../../assets/images/Group 5.png")}
          alt="Wave 1"
          sx={{
            position: "absolute",
            width: "100%",
            height: "auto",
            minHeight: "200px", // Ensure the wave is tall enough
            zIndex: 1,
          }}
        />
      </Box>
    </>
  );
};
